import { DEBUGSTATE } from '.'
import { FloaterModal } from '../../types/state'
import { FloaterSize } from '../constants/enums'
import { FLOATING_DEBUG } from '../constants/floaters'
import { customStateWrapper } from './customStateWrapper'
import { generateModalKey, setMultiModal } from './internal/modals'
import { pubSubDebug } from './pubSub'

const circularReplacer = (seen = new WeakSet()) => {
    return (_, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return
            }
            seen.add(value)
        }
        return value
    }
}

export const updateDebugLog = customStateWrapper<any[], { clear: boolean }>(
    () => {
        pubSubDebug.emit('state', DEBUGSTATE)
    },
)((args, options = { clear: false }) => {
    if (options.clear) {
        DEBUGSTATE.debug.log = []
        return
    } else if (DEBUGSTATE.debug.log.length >= 100) {
        DEBUGSTATE.debug.log.splice(0, DEBUGSTATE.debug.log.length - 100)
    }
    DEBUGSTATE.debug = {
        log: [
            JSON.stringify(args, circularReplacer(), 2),
            ...DEBUGSTATE.debug.log,
        ],
    }
})

export const openFloatingDebug = (overrideOptions?: Partial<FloaterModal>) => {
    // hook into console.log
    if (!console.hooked) {
        console.hooked = true
        const originalLog = console.log
        console.log = (...args) => {
            // const tempError = Error()
            // const fnName = tempError.name
            // const fnLine = tempError.stack.split('\n')[2]
            updateDebugLog(args)
            originalLog(...args)
        }
    }
    const defaultLocation = {
        x: 40,
        y: 40,
        speedX: 0,
        speedY: 0,
        width: 0,
    }
    setMultiModal(generateModalKey(FLOATING_DEBUG), {
        // id,
        minimized: true,
        show: true,
        type: FLOATING_DEBUG,
        sticky: true,
        locations: {
            portrait: defaultLocation,
            landscape: defaultLocation,
        },
        size: FloaterSize.Large,
        ...overrideOptions,
    })
}
